import { render, staticRenderFns } from "./ArquivoUpload.vue?vue&type=template&id=0cffd4da&scoped=true"
import script from "./ArquivoUpload.vue?vue&type=script&lang=js"
export * from "./ArquivoUpload.vue?vue&type=script&lang=js"
import style0 from "./ArquivoUpload.vue?vue&type=style&index=0&id=0cffd4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffd4da",
  null
  
)

export default component.exports